import { useMemo, useState } from 'react';

const compareValues = (aVal, bVal, sortField, sortOrder) => {
  let a = aVal;
  let b = bVal;
  if (sortField === 'amount') {
    a = a || 0;
    b = b || 0;
  } else if (sortField === 'created_at' || sortField === 'drafted_date') {
    a = a ? new Date(a).getTime() : 0;
    b = b ? new Date(b).getTime() : 0;
  } else {
    a = (a || '').toString().toLowerCase();
    b = (b || '').toString().toLowerCase();
  }
  if (sortOrder === 'asc') return a > b ? 1 : -1;
  return a < b ? 1 : -1;
};

const matchesSearch = (proposal, term, companies) => {
  if (!term) return true;
  const t = term.toLowerCase();
  return proposal.title?.toLowerCase().includes(t) ||
    proposal.client_name?.toLowerCase().includes(t) ||
    (proposal.company_id && companies.find((c) => c.company_id === proposal.company_id)?.name?.toLowerCase().includes(t));
};

export const useProposalsSorting = (proposals, companies, search, statusFilter) => {
  const [sortField, setSortField] = useState('created_at');
  const [sortOrder, setSortOrder] = useState('desc');

  const sortedProposals = useMemo(() => {
    return [...proposals]
      .filter((p) => {
        if (statusFilter !== 'all' && p.status !== statusFilter) return false;
        return matchesSearch(p, search, companies);
      })
      .sort((a, b) => compareValues(a[sortField], b[sortField], sortField, sortOrder));
  }, [proposals, companies, search, statusFilter, sortField, sortOrder]);

  const toggleSort = (field) => {
    if (sortField === field) {
      setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
    } else {
      setSortField(field);
      setSortOrder('asc');
    }
  };

  return { sortedProposals, sortField, toggleSort };
};
